import { TransferQuoteResult } from "src/api-service";

// **************************************************************************
// TRANSFER QUOTES STATE
// **************************************************************************
export interface TransferQuotesState {
    result: TransferQuoteResult | undefined;
    loading: boolean;
}

export const initialTransferQuotesState: TransferQuotesState = {
    result: undefined,
    loading: false,
};
